<div class="section-container">
  <div class="section-header px-3 pb-2">
    <mat-icon class="header-icon">{{ icon() }}</mat-icon>
    <div class="header-text">
      <h5 class="m-0 fw-bold">{{ cardTitle() | translate }}</h5>
    </div>
    <div class="header-divider-wrap">
      <mat-divider class="header-divider"></mat-divider>
    </div>
    @if (hasDialog()) {
    <div class="card-actions">
      <a class="show-more-btn" (click)="openDialog()">
        {{ buttonLabelKey() | translate }}
      </a>
    </div>
    }
  </div>
  <div class="content-box">
    @for (field of fields(); track field.label) {
    <div class="info-row">
      <div class="label-group">
        <span class="dot-icon"></span>
        <span class="label">{{ field.label | translate }}</span>
      </div>
      <span class="value">
        @if (typeof field.value === 'boolean') {
        <av-bool-cell [value]="field.value" />
        } @else if (field.routerLink?.length && field.value != null && field.value !== '') {
        <a [routerLink]="field.routerLink" class="av-card-link">{{ field.value }}</a>
        } @else if (field.value != null && field.value !== '') {
        {{ field.value }}
        } @else {
        {{ 'shared.general.labels.na' | translate }}
        }
      </span>
    </div>
    }
  </div>
</div>